module.exports = require('./FileUploadTableFreeTextView');
